module.exports = require('./FileUploadTableFreeTextView');
